import { PermissionT } from "../types";

export const usersUpdate = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "user_management");
  return !!p && !!p?.actions?.includes("update");
};

export default usersUpdate;
